export default "https://cdn-static.gokick.com/assets/f85860d356d81c773b535a0002382fa42e6b6edf/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";